import React, { FC, ReactNode, HTMLAttributes } from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';

export type FlexProps = {
  children?: ReactNode;
  direction?: 'column' | 'row';
  align?: 'start' | 'center' | 'end';
  justify?: 'start' | 'end' | 'center' | 'space-between' | 'space-around';
  fullWidth?: boolean;
  fullHeight?: boolean;
  wrap?: boolean;
  gap?: '0' | 'xs' | 's' | 'm' | 'l' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl' | '8xl';
} & HTMLAttributes<HTMLDivElement>;

export const Flex: FC<FlexProps> = ({
  fullWidth = false,
  fullHeight = false,
  wrap = false,
  ...props
}) => {
  const { children, direction = 'row', gap = '0', align, justify } = props;
  return (
    <div
      {...props}
      className={clsx(
        styles.base,
        styles[`_${direction}`],
        align && styles[`_align_${align}`],
        justify && styles[`_justify_${justify}`],
        gap && styles[`_gap_${gap}`],
        fullWidth && styles['_full-width'],
        fullHeight && styles['_full-height'],
        wrap && styles['_wrap'],
        props.className
      )}
    >
      {children}
    </div>
  );
};

export default Flex;
